const SignupResponseStructure = {
    status: "", // success or failure
    securityToken: "", // Token for future authentication
    userId: "", // Unique ID assigned to the user
    message: "", // Response message (e.g., "Signup successful" or "Email already exists")
  };
  
  export default SignupResponseStructure;
  